<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        权限管理
      </div>
      <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <!--                <div class="btn"><i class="icon-tr-search"></i>查询</div>-->
        <div class="btn ml20" @click="$router.push('/power/power-add')">
          <i class="icon-tr-newly-added"></i>新增
        </div>
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column
            prop="menu_name"
            label="权限名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="father_menu_key"
            align="center"
            label="所属上级"
          ></el-table-column>
          <el-table-column
            prop="menu_key"
            align="center"
            label="权限编码"
          ></el-table-column>
          <el-table-column prop="tr_user_name" align="center" label="权限类型">
            <template slot-scope="scope">{{
              $map.roleType[scope.row.menu_type]
            }}</template>
          </el-table-column>
          <!--                    <el-table-column-->
          <!--                            prop="create_time"-->
          <!--                            align="center"-->
          <!--                            label="创建时间">-->
          <!--                    </el-table-column>-->
          <el-table-column prop="tr_user_phone" align="center" label="状态">
            <template slot-scope="scope">{{
              $map.menuStatus[scope.row.status]
            }}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{ path: '/power/power-add', query: { id: scope.row.id } }"
              >
                <el-button type="warning" size="mini" plain>编辑</el-button>
              </router-link>
              <el-popconfirm
                v-if="scope.row.status == 1"
                title="确定禁用此记录吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row.id, 0)"
                @confirm="changeStatus(scope.row.id, 0)"
              >
                <a slot="reference" class="red">
                  <el-button type="danger" size="mini" plain>删除</el-button>
                </a>
              </el-popconfirm>
              <el-popconfirm
                v-if="scope.row.status == 0"
                title="确定启用此记录吗？"
                class="cursor"
                @onConfirm="changeStatus(scope.row.id, 1)"
                @confirm="changeStatus(scope.row.id, 1)"
              >
                <a slot="reference">
                  <el-button type="primary">开启</el-button>
                </a>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        @current-change="changeSize"
        layout="prev, pager, next"
        :page-size="params.limit"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { menulist, delmenu } from "../../api/menu";
export default {
  data() {
    return {
      list: [],
      params: { page: 1, limit: 10 },
      total: 0,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeStatus(id, status) {
      delmenu({ id: id })
        .then((res) => {
          this.getList();
        })
        .catch((err) => {});
    },
    getList() {
      menulist(this.params)
        .then((res) => {
          this.total = res.count;
          this.list = res.data.list;
        })
        .catch((res) => {
          this.$message.error("获取列表失败");
        });
    },
    changeSize(page) {
      this.params.page = page;
      this.getList();
    },
  },
};
</script>

<style scoped>
</style>
